export const HOME_CHANGE_DRAWER_STATE = "HOME_CHANGE_DRAWER_STATE";
export const HOME_SELECTED_ENTRY = "HOME_SELECTED_ENTRY";
export const HOME_LOGOUT = "HOME_LOGOUT";
export const HOME_GET_UNASSIGNED_ISSUES = "HOME_GET_UNASSIGNED_ISSUES";
export const HOME_GET_UNASSIGNED_ISSUES_SUCCESS = "HOME_GET_UNASSIGNED_ISSUES_SUCCESS";